<template>
<div>
	<div class="float-right">
		<button class="btn btn-primary" v-on:click="addTask"><i class="fa fa-lock"></i> Lock from Editing</button>

		<button v-if="$store.project.estimate_locked == 0" class="btn btn-success" v-on:click="addTask"><i class="fa fa-plus"></i> Add Task</button>

		<button v-else class="btn btn-success" v-on:click="addDraw"><i class="fa fa-plus"></i> Add Draw</button>
	</div>

	<h2>Draw Breakdown on {{$store.project.job_name}}</h2>

	<table-list
		:records="mutatedTasks"
		:fields="fields"
		record-name="Task"
		:has-edit="editable"
		id-field="slug"
		v-on:edit="editTask">
	</table-list>

	<modal-dialog
		:modal-visible="taskModal.visible"
		:title="taskModal.title"
		confirm-button-text="Save"
		v-on:confirm="saveTask"
		v-on:closeModal="taskModal.visible = false">

		<field label="Description" col-class="col-md-4" :form-group="true"  ></field>
		<field label="Qty" col-class="col-md-4" :form-group="true" :params="{type: 'number', min:0,step:0.01}" ></field>
		<field label="Unit Value" col-class="col-md-4" :form-group="true" :params="{type: 'number',step:0.01,min:0}" ></field>
	</modal-dialog>
</div>
</template>

<script>

import Field from "../../../components/Field"
import TableList from "../../../components/TableList"
import ModalDialog from "../../../components/ModalDialog"

export default {

	name: 'ProjectTasksDraw',
	components: {
		Field,
		TableList,
		ModalDialog
	},
	data() {
		return {
			editable: true,
			fields: [
				{label: "Description", key: "description"},
				{label: "Qty", key: "qty"},
				{label: "Unit Value", key: "unit_value"},
				{label: "Total Value", key: "totalValue"},
				{label: "Qty to Date", key: "qtyComplete"},
				{label: "% to Date", key: "percentComplete"},
				{label: "$ to Date", key: "dollarsComplete"},
			],
			taskModal: {
				visible: false,
				title: "Add Draw Task",

			}
		}
	},
	computed: {
		mutatedTasks() {

		}
	},
	methods: {
		editTask() {

		},
		addTask() {
			this.taskModal.visible = true
			this.taskModal.title = "Add Draw Task"
		},
		saveTask() {

		},
		addDraw() {

		}
	},
	created() {

	}

}
</script>

<style type="text/css">

</style>